import React from 'react'
import { Box, Skeleton } from '@mui/material'

const ContinueButton = () => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'start', mt: 3, mb: 2 }}>
            <Skeleton variant="rectangular" height={44} sx={{ borderRadius: 1, minWidth: 135, px: 4, py: 1 }} />
        </Box>
    )
}

export default ContinueButton
